import type { RacePolls } from "./types";

/** Day the table was compiled, YYYY-MM-DD. */
export const POLLS_AS_OF = "2026-10-30";

/**
 * Recent public polls of Senate and governor races, taken from the
 * pollsters' own releases and compiled by Foresight. Each pollster appears
 * once per race, with its latest poll; polls paid for by a campaign (in any
 * race), a party's campaign group or a group backing one of the race's
 * candidates are left out. `left` and `right` are the shares of the race's
 * left and right sides as races.ts reads them; ranked-choice polls give
 * first choices where released, as respondents are asked. Polls that ended
 * more than POLL_WINDOW_DAYS (model.ts) before POLLS_AS_OF are ignored.
 */
export const RACE_POLLS: RacePolls[] = [
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-25",
        left: 51,
        note: "First choices",
        pollster: "Alaska Survey Research",
        population: "LV",
        right: 31,
        sponsor: null,
      },
      {
        end: "2026-10-16",
        left: 46,
        note: "First choices",
        pollster: "Data for Progress",
        population: "LV",
        right: 28,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 40,
        note: "First choices",
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 20,
        sponsor: null,
      },
    ],
    special: false,
    state: "AK",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-16",
        left: 47,
        note: "First choices",
        pollster: "Data for Progress",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 48,
        note: "Head-to-head question",
        pollster: "Public Policy Polling",
        population: "RV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 44,
        note: "First choices",
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 42,
        sponsor: null,
      },
      {
        end: "2026-10-10",
        left: 48,
        note: "First choices",
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-03",
        left: 47,
        note: "First choices",
        pollster: "Alaska Survey Research",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 50,
        note: "Head-to-head question",
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 43,
        sponsor: null,
      },
    ],
    special: false,
    state: "AK",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-24",
        left: 45,
        pollster: "Blueprint Polling",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-17",
        left: 40,
        pollster: "Cygnal",
        population: "LV",
        right: 51,
        sponsor: "Alabama Daily News and Gray Media Alabama",
      },
      {
        end: "2026-10-16",
        left: 39,
        pollster: "The Alabama Poll",
        population: "LV",
        right: 51,
        sponsor: null,
      },
    ],
    special: false,
    state: "AL",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-24",
        left: 40,
        pollster: "Blueprint Polling",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-17",
        left: 35,
        pollster: "Cygnal",
        population: "LV",
        right: 50,
        sponsor: "Alabama Daily News and Gray Media Alabama",
      },
      {
        end: "2026-10-16",
        left: 35,
        pollster: "The Alabama Poll",
        population: "LV",
        right: 56,
        sponsor: null,
      },
    ],
    special: false,
    state: "AL",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-13",
        left: 32,
        pollster: "Hendrix College",
        population: "LV",
        right: 51,
        sponsor: "Talk Business & Politics",
      },
    ],
    special: false,
    state: "AR",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-28",
        left: 39,
        pollster: "GrayHouse",
        population: "LV",
        right: 55,
        sponsor: "America One Policies",
      },
      {
        end: "2026-10-13",
        left: 41,
        pollster: "Hendrix College",
        population: "LV",
        right: 50,
        sponsor: "Talk Business & Politics",
      },
    ],
    special: false,
    state: "AR",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-28",
        left: 51,
        pollster: "Noble Predictive Insights",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-25",
        left: 51.5,
        pollster: "HighGround",
        population: "LV",
        right: 39.3,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 47.4,
        pollster: "RedBox Research",
        population: "LV",
        right: 42.3,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-06",
        left: 48.9,
        pollster: "Wick",
        population: "LV",
        right: 43.2,
        sponsor: null,
      },
    ],
    special: false,
    state: "AZ",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-25",
        left: 61,
        pollster: "Berkeley IGS",
        population: "LV",
        right: 34,
        sponsor: "Los Angeles Times",
      },
      {
        end: "2026-10-24",
        left: 54,
        pollster: "SurveyUSA",
        population: "LV",
        right: 32,
        sponsor: "KGTV and The San Diego Union-Tribune",
      },
      {
        end: "2026-10-23",
        left: 59,
        pollster: "M3 Strategies",
        population: "LV",
        right: 36,
        sponsor: null,
      },
      {
        end: "2026-10-22",
        left: 61,
        pollster: "PPIC",
        population: "LV",
        right: 37,
        sponsor: null,
      },
      {
        end: "2026-10-20",
        left: 55,
        pollster: "McLaughlin & Associates",
        population: "LV",
        right: 39,
        sponsor: "California Post",
      },
      {
        end: "2026-10-19",
        left: 64,
        pollster: "Emerson College",
        population: "LV",
        right: 36,
        sponsor: null,
      },
      {
        end: "2026-10-16",
        left: 62.8,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 37.2,
        sponsor: null,
      },
      {
        end: "2026-10-14",
        left: 55,
        pollster: "UC Berkeley Citrin Center/TrueDot/Politico",
        population: "LV",
        right: 35,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 57,
        pollster: "Manhattan Institute",
        population: "LV",
        right: 39,
        sponsor: null,
      },
    ],
    special: false,
    state: "CA",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-12",
        left: 51,
        pollster: "Emerson College",
        population: "LV",
        right: 38,
        sponsor: "Nexstar Media",
      },
      {
        end: "2026-10-12",
        left: 58,
        pollster: "Quinnipiac University",
        population: "LV",
        right: 38,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 57,
        pollster: "Wesleyan University/YouGov",
        population: "LV",
        right: 34,
        sponsor: "The Connecticut Project and The Connecticut Mirror",
      },
      {
        end: "2026-10-12",
        left: 59.3,
        pollster: "GreatBlue Research",
        population: "LV",
        right: 32.7,
        sponsor: "CT Insider, Sacred Heart University and WFSB",
      },
    ],
    special: false,
    state: "CT",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-29",
        left: 45,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-27",
        left: 45.5,
        pollster: "St. Pete Polls",
        population: "LV",
        right: 47.8,
        sponsor: "Florida Politics",
      },
      {
        end: "2026-10-25",
        left: 44,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 43.9,
        pollster: "RedBox Research",
        population: "LV",
        right: 49.2,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-23",
        left: 44,
        pollster: "Echelon Insights",
        population: "LV",
        right: 50,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 40,
        pollster: "co/efficient",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-19",
        left: 47,
        pollster: "University of North Florida",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-19",
        left: 48.3,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 51.7,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 42,
        pollster: "Univision/YouGov",
        population: "RV",
        right: 50,
        sponsor: "Univision",
      },
      {
        end: "2026-10-10",
        left: 47,
        pollster: "Change Research",
        population: "LV",
        right: 47,
        sponsor: "Freedom Project USA",
      },
      {
        end: "2026-10-10",
        left: 43.8,
        pollster: "MDW Communications",
        population: "LV",
        right: 45.9,
        sponsor: "EDGE Communications",
      },
      {
        end: "2026-10-09",
        left: 41,
        pollster: "Stetson University",
        population: "LV",
        right: 52,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 45,
        pollster: "YouGov",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-04",
        left: 42,
        pollster: "Targoz Market Research",
        population: "LV",
        right: 52,
        sponsor: "James Madison Institute",
      },
      {
        end: "2026-10-01",
        left: 41,
        pollster: "Mason-Dixon Polling & Strategy",
        population: "LV",
        right: 48,
        sponsor: null,
      },
    ],
    special: false,
    state: "FL",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-29",
        left: 43,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-27",
        left: 44.7,
        pollster: "St. Pete Polls",
        population: "LV",
        right: 49,
        sponsor: "Florida Politics",
      },
      {
        end: "2026-10-27",
        left: 47,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 53,
        sponsor: null,
      },
      {
        end: "2026-10-25",
        left: 44,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 50,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 43,
        pollster: "RedBox Research",
        population: "LV",
        right: 50,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-23",
        left: 43,
        pollster: "Echelon Insights",
        population: "LV",
        right: 51,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 40,
        pollster: "co/efficient",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-19",
        left: 45,
        pollster: "University of North Florida",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 42,
        pollster: "Univision/YouGov",
        population: "RV",
        right: 51,
        sponsor: "N+ Univision",
      },
      {
        end: "2026-10-10",
        left: 42,
        pollster: "MDW Communications",
        population: "LV",
        right: 48,
        sponsor: "EDGE Communications",
      },
      {
        end: "2026-10-09",
        left: 41,
        pollster: "Stetson University",
        population: "LV",
        right: 52,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 44,
        pollster: "YouGov",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-04",
        left: 42,
        pollster: "Targoz Market Research",
        population: "LV",
        right: 52,
        sponsor: "James Madison Institute",
      },
      {
        end: "2026-10-01",
        left: 40,
        pollster: "Mason-Dixon Polling & Strategy",
        population: "LV",
        right: 50,
        sponsor: "NBC 6 / Telemundo Station Group",
      },
    ],
    special: true,
    state: "FL",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-27",
        left: 50,
        pollster: "State Navigate",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 49,
        pollster: "Echelon Insights",
        population: "LV",
        right: 48,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 48.5,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 51.5,
        sponsor: null,
      },
      {
        end: "2026-10-17",
        left: 47.5,
        pollster: "Quantus Insights",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 45,
        pollster: "University of Georgia",
        population: "LV",
        right: 46,
        sponsor: "The Atlanta Journal-Constitution",
      },
      {
        end: "2026-10-13",
        left: 47,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 49,
        sponsor: null,
      },
    ],
    special: false,
    state: "GA",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-23",
        left: 55,
        pollster: "Echelon Insights",
        population: "LV",
        right: 40,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 54,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 46,
        sponsor: null,
      },
      {
        end: "2026-10-17",
        left: 51.8,
        pollster: "Quantus Insights",
        population: "LV",
        right: 44.9,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 48,
        pollster: "University of Georgia",
        population: "LV",
        right: 40,
        sponsor: "The Atlanta Journal-Constitution",
      },
      {
        end: "2026-10-09",
        left: 51,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 43,
        sponsor: null,
      },
    ],
    special: false,
    state: "GA",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-28",
        left: 50,
        pollster: "co/efficient",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 50,
        pollster: "Echelon Insights",
        population: "LV",
        right: 46,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-13",
        left: 54,
        pollster: "GS Strategy Group/New River Strategies",
        population: "LV",
        right: 43,
        sponsor: "The Cook Political Report",
      },
      {
        end: "2026-10-12",
        left: 50,
        pollster: "National Public Affairs",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 50,
        pollster: "YouGov",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-11",
        left: 52,
        pollster: "Marist University",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-06",
        left: 49,
        pollster: "Emerson College",
        population: "LV",
        right: 45,
        sponsor: "Nexstar Media",
      },
      {
        end: "2026-10-05",
        left: 51,
        pollster: "SSRS",
        population: "LV",
        right: 42,
        sponsor: "CNN",
      },
      {
        end: "2026-10-04",
        left: 54.8,
        pollster: "Suffolk University",
        population: "LV",
        right: 42.8,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 52,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 41,
        sponsor: null,
      },
    ],
    special: false,
    state: "IA",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-28",
        left: 46,
        pollster: "co/efficient",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 45,
        pollster: "Echelon Insights",
        population: "LV",
        right: 43,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-22",
        left: 45,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 44.2,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 45.9,
        sponsor: null,
      },
      {
        end: "2026-10-13",
        left: 46,
        pollster: "GS Strategy Group/New River Strategies",
        population: "LV",
        right: 44,
        sponsor: "The Cook Political Report",
      },
      {
        end: "2026-10-12",
        left: 44,
        pollster: "National Public Affairs",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 47,
        pollster: "YouGov",
        population: "LV",
        right: 46,
        sponsor: null,
      },
      {
        end: "2026-10-11",
        left: 48,
        pollster: "Marist University",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-06",
        left: 45,
        pollster: "Emerson College",
        population: "LV",
        right: 47,
        sponsor: "Nexstar Media",
      },
      {
        end: "2026-10-05",
        left: 43,
        pollster: "SSRS",
        population: "LV",
        right: 45,
        sponsor: "CNN",
      },
      {
        end: "2026-10-04",
        left: 48,
        pollster: "Suffolk University",
        population: "LV",
        right: 43.6,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 47,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 48,
        sponsor: null,
      },
    ],
    special: false,
    state: "IA",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-22",
        left: 58.7,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 41.3,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 54,
        pollster: "Public Policy Polling",
        population: "LV",
        right: 34,
        sponsor: "Chicago News Weekly",
      },
    ],
    special: false,
    state: "IL",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-30",
        left: 55.6,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 44.4,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 49,
        pollster: "Public Policy Polling",
        population: "LV",
        right: 36,
        sponsor: "Chicago News Weekly",
      },
    ],
    special: false,
    state: "IL",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-28",
        left: 46,
        pollster: "Emerson College",
        population: "LV",
        right: 50,
        sponsor: null,
      },
      {
        end: "2026-10-26",
        left: 51,
        pollster: "The Washington Post/George Mason University Schar School",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-26",
        left: 45,
        pollster: "SSRS",
        population: "LV",
        right: 50,
        sponsor: "CNN",
      },
      {
        end: "2026-10-23",
        left: 45.6,
        pollster: "RedBox Research",
        population: "LV",
        right: 48,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-04",
        left: 44,
        pollster: "YouGov",
        population: "LV",
        right: 47,
        sponsor: null,
      },
    ],
    special: false,
    state: "KS",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-28",
        left: 49,
        pollster: "Emerson College",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-26",
        left: 52,
        pollster: "The Washington Post/George Mason University Schar School",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-26",
        left: 49,
        pollster: "SSRS",
        population: "LV",
        right: 45,
        sponsor: "CNN",
      },
      {
        end: "2026-10-23",
        left: 45,
        pollster: "RedBox Research",
        population: "LV",
        right: 46,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-14",
        left: 47,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-04",
        left: 48,
        pollster: "YouGov",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 44.4,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 43.5,
        sponsor: null,
      },
    ],
    special: false,
    state: "KS",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-18",
        left: 57,
        pollster: "UMass Lowell/YouGov",
        population: "LV",
        right: 29,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 58.6,
        pollster: "Suffolk University",
        population: "LV",
        right: 36,
        sponsor: "The Boston Globe",
      },
      {
        end: "2026-10-12",
        left: 57,
        pollster: "UMass Amherst/YouGov",
        population: "RV",
        right: 32,
        sponsor: "WCVB",
      },
    ],
    special: false,
    state: "MA",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-18",
        left: 60,
        pollster: "Suffolk University",
        population: "LV",
        right: 31.8,
        sponsor: "The Boston Globe",
      },
      {
        end: "2026-10-18",
        left: 55,
        pollster: "UMass Lowell/YouGov",
        population: "LV",
        right: 26,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 54,
        pollster: "UMass Amherst/YouGov",
        population: "RV",
        right: 28,
        sponsor: "WCVB",
      },
    ],
    special: false,
    state: "MA",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-26",
        left: 53,
        pollster: "SSRS",
        population: "LV",
        right: 39,
        sponsor: "CNN",
      },
      {
        end: "2026-10-25",
        left: 44,
        pollster: "Marist University",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 51,
        pollster: "Echelon Insights",
        population: "LV",
        right: 38,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 49,
        pollster: "Beacon Research/Shaw & Co. Research",
        population: "LV",
        right: 39,
        sponsor: "Fox News",
      },
      {
        end: "2026-10-11",
        left: 49,
        pollster: "Suffolk University",
        population: "LV",
        right: 38,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 49,
        pollster: "The Washington Post/George Mason University Schar School",
        population: "LV",
        right: 36,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 56,
        note: "Two-way question; Bennett not offered",
        pollster: "CBS News/YouGov",
        population: "LV",
        right: 44,
        sponsor: "CBS News",
      },
    ],
    special: false,
    state: "ME",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-26",
        left: 49,
        pollster: "SSRS",
        population: "LV",
        right: 45,
        sponsor: "CNN",
      },
      {
        end: "2026-10-25",
        left: 49,
        pollster: "Marist University",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 46.5,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 51,
        pollster: "Echelon Insights",
        population: "LV",
        right: 44,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 49,
        pollster: "Beacon Research/Shaw & Co. Research",
        population: "LV",
        right: 49,
        sponsor: "Fox News",
      },
      {
        end: "2026-10-14",
        left: 49,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-11",
        left: 49,
        pollster: "Suffolk University",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 49,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 50,
        pollster: "The Washington Post/George Mason University Schar School",
        population: "LV",
        right: 46,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 50,
        pollster: "CBS News/YouGov",
        population: "LV",
        right: 50,
        sponsor: "CBS News",
      },
    ],
    special: false,
    state: "ME",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-27",
        left: 49,
        pollster: "Mitchell Research & Communications",
        population: "LV",
        right: 44,
        sponsor: "CBS Detroit",
      },
      {
        end: "2026-10-27",
        left: 53,
        pollster: "SSRS",
        population: "LV",
        right: 41,
        sponsor: "CNN",
      },
      {
        end: "2026-10-23",
        left: 48.5,
        pollster: "Michigan State University/Verasight",
        population: "LV",
        right: 38.7,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 48.6,
        pollster: "RedBox Research",
        population: "LV",
        right: 42.8,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-22",
        left: 51.4,
        pollster: "Glengariff Group",
        population: "LV",
        right: 44.5,
        sponsor: "The Detroit News and WDIV-TV",
      },
      {
        end: "2026-10-19",
        left: 51.5,
        pollster: "Michigan State University IPPSR/YouGov",
        population: "LV",
        right: 39.7,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 51,
        pollster: "Marist University",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-04",
        left: 48,
        pollster: "YouGov",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 50,
        pollster: "Z to A Research",
        population: "LV",
        right: 40,
        sponsor: "Rust Belt Rising",
      },
    ],
    special: false,
    state: "MI",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-29",
        left: 49,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-28",
        left: 50,
        pollster: "Upswing Research",
        population: "LV",
        right: 45,
        sponsor: "Demand Justice",
      },
      {
        end: "2026-10-27",
        left: 51,
        pollster: "Mitchell Research & Communications",
        population: "LV",
        right: 44,
        sponsor: "CBS Detroit",
      },
      {
        end: "2026-10-27",
        left: 49,
        pollster: "SSRS",
        population: "LV",
        right: 42,
        sponsor: "CNN",
      },
      {
        end: "2026-10-23",
        left: 49,
        pollster: "RedBox Research",
        population: "LV",
        right: 44,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-23",
        left: 48,
        pollster: "Michigan State University/Verasight",
        population: "LV",
        right: 41.8,
        sponsor: null,
      },
      {
        end: "2026-10-22",
        left: 47,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 46,
        sponsor: null,
      },
      {
        end: "2026-10-22",
        left: 51.4,
        pollster: "Glengariff Group",
        population: "LV",
        right: 45.1,
        sponsor: "The Detroit News and WDIV-TV",
      },
      {
        end: "2026-10-19",
        left: 47.7,
        pollster: "Michigan State University IPPSR/YouGov",
        population: "LV",
        right: 44.2,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 50,
        pollster: "Marist University",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 44,
        pollster: "The Tyson Group",
        population: "LV",
        right: 46,
        sponsor: "Alliance for a Better Future",
      },
      {
        end: "2026-10-06",
        left: 48.4,
        pollster: "Quantus Insights",
        population: "LV",
        right: 47.2,
        sponsor: null,
      },
      {
        end: "2026-10-04",
        left: 49,
        pollster: "YouGov",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 49,
        pollster: "Z to A Research",
        population: "LV",
        right: 42,
        sponsor: "Rust Belt Rising",
      },
    ],
    special: false,
    state: "MI",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-28",
        left: 52,
        pollster: "State Navigate",
        population: "LV",
        right: 42,
        sponsor: null,
      },
      {
        end: "2026-10-26",
        left: 56,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 38,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 48,
        pollster: "SurveyUSA",
        population: "LV",
        right: 41,
        sponsor: "KSTP-TV",
      },
      {
        end: "2026-10-07",
        left: 50,
        pollster: "Mason-Dixon Polling & Strategy",
        population: "LV",
        right: 41,
        sponsor: "KARE 11 and The Minnesota Star Tribune",
      },
      {
        end: "2026-10-07",
        left: 48,
        pollster: "Morning Consult",
        population: "RV",
        right: 39,
        sponsor: "The Daily Agenda",
      },
    ],
    special: false,
    state: "MN",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-26",
        left: 54,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 40,
        sponsor: null,
      },
      {
        end: "2026-10-21",
        left: 48,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 48.1,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 44.6,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 45,
        pollster: "SurveyUSA",
        population: "LV",
        right: 42,
        sponsor: "KSTP-TV",
      },
      {
        end: "2026-10-07",
        left: 47,
        pollster: "Mason-Dixon Polling & Strategy",
        population: "LV",
        right: 43,
        sponsor: "KARE 11 and The Minnesota Star Tribune",
      },
      {
        end: "2026-10-07",
        left: 45,
        pollster: "Morning Consult",
        population: "RV",
        right: 41,
        sponsor: "The Daily Agenda",
      },
    ],
    special: false,
    state: "MN",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-22",
        left: 40,
        pollster: "Change Research",
        population: "LV",
        right: 43,
        sponsor: "Government That Works PAC",
      },
    ],
    special: false,
    state: "MS",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-23",
        left: 39,
        pollster: "Concord Public Opinion Partners",
        population: "LV",
        right: 38,
        sponsor: "Education Reform Now Advocacy",
      },
      {
        end: "2026-10-21",
        left: 26,
        pollster: "Montana State University Billings",
        population: "A",
        right: 30,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 28,
        pollster: "Quantus Insights",
        population: "LV",
        right: 44,
        sponsor: null,
      },
    ],
    special: false,
    state: "MT",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-25",
        left: 51.4,
        pollster: "Quantus Insights",
        population: "LV",
        right: 42.8,
        sponsor: null,
      },
      {
        end: "2026-10-20",
        left: 49.4,
        pollster: "Harper Polling",
        population: "LV",
        right: 39.1,
        sponsor: "Carolina Journal",
      },
      {
        end: "2026-10-20",
        left: 56.9,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 43.1,
        sponsor: null,
      },
      {
        end: "2026-10-20",
        left: 54,
        pollster: "High Point University/YouGov",
        population: "LV",
        right: 40,
        sponsor: null,
      },
      {
        end: "2026-10-11",
        left: 54,
        pollster: "SurveyUSA",
        population: "LV",
        right: 40,
        sponsor: "WRAL-TV / WSOC-TV",
      },
      {
        end: "2026-10-10",
        left: 48.8,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 40.9,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 52,
        pollster: "Elon University/YouGov",
        population: "LV",
        right: 39,
        sponsor: null,
      },
      {
        end: "2026-10-07",
        left: 50,
        pollster: "Change Research",
        population: "LV",
        right: 40,
        sponsor: "Carolina Forward",
      },
      {
        end: "2026-10-03",
        left: 50,
        pollster: "East Carolina University",
        population: "LV",
        right: 43,
        sponsor: null,
      },
    ],
    special: false,
    state: "NC",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-23",
        left: 40,
        pollster: "Echelon Insights",
        population: "LV",
        right: 47,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-18",
        left: 41,
        pollster: "National Public Affairs",
        population: "LV",
        right: 47,
        sponsor: "God, Family, & Country PAC",
      },
      {
        end: "2026-10-18",
        left: 43,
        pollster: "Concord Public Opinion Partners",
        population: "LV",
        right: 40,
        sponsor: "Education Reform Now Advocacy",
      },
      {
        end: "2026-10-03",
        left: 43,
        pollster: "YouGov",
        population: "LV",
        right: 44,
        sponsor: null,
      },
    ],
    special: false,
    state: "NE",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-23",
        left: 46,
        pollster: "Echelon Insights",
        population: "LV",
        right: 47,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-18",
        left: 48,
        pollster: "Concord Public Opinion Partners",
        population: "LV",
        right: 41,
        sponsor: "Education Reform Now Advocacy",
      },
      {
        end: "2026-10-18",
        left: 43,
        pollster: "National Public Affairs",
        population: "LV",
        right: 46,
        sponsor: null,
      },
      {
        end: "2026-10-03",
        left: 48,
        pollster: "YouGov",
        population: "LV",
        right: 47,
        sponsor: null,
      },
    ],
    special: false,
    state: "NE",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-23",
        left: 42,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 52,
        sponsor: null,
      },
      {
        end: "2026-10-20",
        left: 42,
        pollster: "Saint Anselm College Survey Center",
        population: "LV",
        right: 50,
        sponsor: null,
      },
      {
        end: "2026-10-19",
        left: 42,
        pollster: "UMass Lowell/YouGov",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 38,
        pollster: "National Public Affairs",
        population: "LV",
        right: 54,
        sponsor: "God, Family, & Country PAC",
      },
      {
        end: "2026-10-05",
        left: 40,
        pollster: "YouGov",
        population: "LV",
        right: 49,
        sponsor: null,
      },
    ],
    special: false,
    state: "NH",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-23",
        left: 50,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-20",
        left: 50,
        pollster: "Saint Anselm College Survey Center",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-19",
        left: 48,
        pollster: "UMass Lowell/YouGov",
        population: "LV",
        right: 41,
        sponsor: null,
      },
      {
        end: "2026-10-12",
        left: 50,
        pollster: "National Public Affairs",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 51,
        pollster: "YouGov",
        population: "LV",
        right: 43,
        sponsor: null,
      },
    ],
    special: false,
    state: "NH",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-09",
        left: 49,
        pollster: "Research & Polling Inc.",
        population: "LV",
        right: 42,
        sponsor: "Albuquerque Journal",
      },
    ],
    special: false,
    state: "NM",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-09",
        left: 53,
        pollster: "Research & Polling Inc.",
        population: "LV",
        right: 37,
        sponsor: "Albuquerque Journal",
      },
    ],
    special: false,
    state: "NM",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-28",
        left: 47,
        pollster: "Noble Predictive Insights",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 45.6,
        pollster: "RedBox Research",
        population: "LV",
        right: 42.6,
        sponsor: "A Fight Worth Having",
      },
    ],
    special: false,
    state: "NV",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-25",
        left: 53,
        pollster: "Marist University",
        population: "LV",
        right: 42,
        sponsor: null,
      },
      {
        end: "2026-10-23",
        left: 59,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 41,
        sponsor: null,
      },
      {
        end: "2026-10-22",
        left: 54,
        pollster: "Siena College Research Institute",
        population: "LV",
        right: 40,
        sponsor: null,
      },
      {
        end: "2026-10-19",
        left: 55,
        pollster: "Quinnipiac University",
        population: "LV",
        right: 41,
        sponsor: null,
      },
      {
        end: "2026-10-06",
        left: 53,
        pollster: "Beacon Research",
        population: "RV",
        right: 31,
        sponsor: "Secure AI Project",
      },
      {
        end: "2026-10-05",
        left: 52,
        pollster: "Emerson College",
        population: "LV",
        right: 40,
        sponsor: "PIX11",
      },
    ],
    special: false,
    state: "NY",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-26",
        left: 48,
        pollster: "Suffolk University",
        population: "LV",
        right: 44,
        sponsor: "USA TODAY Network Ohio",
      },
      {
        end: "2026-10-23",
        left: 48.2,
        pollster: "RedBox Research",
        population: "LV",
        right: 43.8,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-23",
        left: 45,
        pollster: "Echelon Insights",
        population: "LV",
        right: 47,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-20",
        left: 46.2,
        pollster: "Verasight",
        population: "LV",
        right: 45.4,
        sponsor: "VoteHub",
      },
      {
        end: "2026-10-19",
        left: 50,
        pollster: "Beacon Research/Shaw & Co. Research",
        population: "LV",
        right: 48,
        sponsor: "Fox News",
      },
      {
        end: "2026-10-19",
        left: 48.6,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 51.4,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 50,
        pollster: "Marist University",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-13",
        left: 49,
        pollster: "GS Strategy Group/New River Strategies",
        population: "LV",
        right: 44,
        sponsor: "The Cook Political Report",
      },
      {
        end: "2026-10-09",
        left: 50,
        pollster: "Bowling Green State University/YouGov",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-06",
        left: 43,
        pollster: "co/efficient",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 50,
        pollster: "SSRS",
        population: "LV",
        right: 42,
        sponsor: "CNN",
      },
      {
        end: "2026-10-01",
        left: 49,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 45,
        sponsor: null,
      },
    ],
    special: false,
    state: "OH",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-26",
        left: 46.6,
        pollster: "Suffolk University",
        population: "LV",
        right: 43.8,
        sponsor: "USA TODAY Network Ohio",
      },
      {
        end: "2026-10-23",
        left: 46.9,
        pollster: "RedBox Research",
        population: "LV",
        right: 44.2,
        sponsor: "A Fight Worth Having",
      },
      {
        end: "2026-10-23",
        left: 47,
        pollster: "Echelon Insights",
        population: "LV",
        right: 47,
        sponsor: "NetChoice",
      },
      {
        end: "2026-10-22",
        left: 47,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-20",
        left: 47.5,
        pollster: "Verasight",
        population: "LV",
        right: 43.6,
        sponsor: "VoteHub",
      },
      {
        end: "2026-10-19",
        left: 52,
        pollster: "Beacon Research/Shaw & Co. Research",
        population: "LV",
        right: 47,
        sponsor: "Fox News",
      },
      {
        end: "2026-10-18",
        left: 48,
        pollster: "Marist University",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 49.8,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 50.2,
        sponsor: null,
      },
      {
        end: "2026-10-14",
        left: 47,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-13",
        left: 49,
        pollster: "GS Strategy Group/New River Strategies",
        population: "LV",
        right: 43,
        sponsor: "The Cook Political Report",
      },
      {
        end: "2026-10-09",
        left: 48,
        pollster: "Bowling Green State University/YouGov",
        population: "LV",
        right: 42,
        sponsor: null,
      },
      {
        end: "2026-10-06",
        left: 43,
        pollster: "co/efficient",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 49,
        pollster: "SSRS",
        population: "LV",
        right: 43,
        sponsor: "CNN",
      },
      {
        end: "2026-10-01",
        left: 49,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 46,
        sponsor: null,
      },
    ],
    special: true,
    state: "OH",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-28",
        left: 43,
        note: "Headline; the pollster's alternative weighting has Munson 54.5–36.3",
        pollster: "Cross Timbers Poll",
        population: "LV",
        right: 46,
        sponsor: null,
      },
    ],
    special: false,
    state: "OK",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-01",
        left: 46,
        pollster: "DHM Research",
        population: "LV",
        right: 44,
        sponsor: "The Oregonian/OregonLive",
      },
    ],
    special: false,
    state: "OR",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-21",
        left: 61.5,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 38.5,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 59,
        pollster: "Franklin & Marshall College",
        population: "LV",
        right: 36,
        sponsor: null,
      },
      {
        end: "2026-10-11",
        left: 58,
        pollster: "Bravo Group",
        population: "RV",
        right: 28,
        sponsor: "PennLive",
      },
      {
        end: "2026-10-05",
        left: 59,
        pollster: "Quinnipiac University",
        population: "LV",
        right: 34,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 53,
        pollster: "Z to A Research",
        population: "LV",
        right: 34,
        sponsor: "Rust Belt Rising",
      },
    ],
    special: false,
    state: "PA",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-11",
        left: 44,
        pollster: "Emerson College",
        population: "LV",
        right: 10,
        sponsor: "WPRI-TV 12 News",
      },
      {
        end: "2026-10-08",
        left: 39,
        pollster: "Embold Research",
        population: "LV",
        right: 17,
        sponsor: "Pell Center for International Relations and Public Policy",
      },
    ],
    special: false,
    state: "RI",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-11",
        left: 59,
        pollster: "Emerson College",
        population: "LV",
        right: 25,
        sponsor: "WPRI-TV 12 News",
      },
      {
        end: "2026-10-08",
        left: 55,
        pollster: "Embold Research",
        population: "LV",
        right: 32,
        sponsor: "Pell Center for International Relations and Public Policy",
      },
    ],
    special: false,
    state: "RI",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-26",
        left: 44,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 51,
        sponsor: null,
      },
      {
        end: "2026-10-25",
        left: 41,
        pollster: "Targoz Market Research",
        population: "LV",
        right: 51,
        sponsor: "South Carolina Policy Council",
      },
      {
        end: "2026-10-25",
        left: 31,
        pollster: "The Citadel",
        population: "LV",
        right: 42,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 36.5,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 52.5,
        sponsor: null,
      },
      {
        end: "2026-10-03",
        left: 35.03,
        pollster: "Resonance Media Services",
        population: "RV",
        right: 45.17,
        sponsor: null,
      },
    ],
    special: false,
    state: "SC",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-29",
        left: 48,
        pollster: "Patinkin Research Strategies",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-26",
        left: 48,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-25",
        left: 46,
        pollster: "Targoz Market Research",
        population: "LV",
        right: 47,
        sponsor: "South Carolina Policy Council",
      },
      {
        end: "2026-10-25",
        left: 39,
        pollster: "The Citadel",
        population: "LV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-24",
        left: 47,
        pollster: "East Carolina University",
        population: "LV",
        right: 51,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 45.6,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 48.6,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 45,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 49,
        sponsor: null,
      },
    ],
    special: false,
    state: "SC",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-26",
        left: 39,
        pollster: "Concord Public Opinion Partners",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-21",
        left: 38,
        pollster: "Emerson College",
        population: "LV",
        right: 56,
        sponsor: "KELOLAND News",
      },
      {
        end: "2026-10-14",
        left: 36,
        pollster: "Mason-Dixon Polling & Strategy",
        population: "LV",
        right: 56,
        sponsor:
          "South Dakota News Watch and USD Chiesman Center for Democracy",
      },
    ],
    special: false,
    state: "SD",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-26",
        left: 43,
        pollster: "Concord Public Opinion Partners",
        population: "LV",
        right: 41,
        sponsor: "Democrats for Education Reform",
      },
      {
        end: "2026-10-20",
        left: 42,
        pollster: "Emerson College",
        population: "LV",
        right: 50,
        sponsor: "KELOLAND News",
      },
      {
        end: "2026-10-19",
        left: 37.3,
        pollster: "Quantus Insights",
        population: "LV",
        right: 59.4,
        sponsor: null,
      },
      {
        end: "2026-10-14",
        left: 37,
        pollster: "Mason-Dixon Polling & Strategy",
        population: "LV",
        right: 56,
        sponsor:
          "South Dakota News Watch and USD Chiesman Center for Democracy",
      },
    ],
    special: false,
    state: "SD",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-16",
        left: 32,
        pollster: "Spry Strategies",
        population: "LV",
        right: 43.5,
        sponsor: null,
      },
    ],
    special: false,
    state: "TN",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-29",
        left: 47.9,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 52.1,
        sponsor: null,
      },
      {
        end: "2026-10-28",
        left: 45.8,
        pollster: "Quantus Insights",
        population: "LV",
        right: 50.7,
        sponsor: null,
      },
      {
        end: "2026-10-27",
        left: 46,
        pollster: "SSRS",
        population: "LV",
        right: 48,
        sponsor: "CNN",
      },
      {
        end: "2026-10-26",
        left: 49,
        pollster: "YouGov Blue",
        population: "LV",
        right: 46,
        sponsor: "254 Labs",
      },
      {
        end: "2026-10-25",
        left: 47,
        pollster: "Texas Southern University",
        population: "LV",
        right: 50,
        sponsor: null,
      },
      {
        end: "2026-10-21",
        left: 46,
        pollster: "N+ Univision/YouGov",
        population: "RV",
        right: 48,
        sponsor: "N+ Univision",
      },
      {
        end: "2026-10-20",
        left: 46.4,
        pollster: "Verasight",
        population: "LV",
        right: 47.7,
        sponsor: "VoteHub",
      },
      {
        end: "2026-10-19",
        left: 45,
        pollster: "Emerson College",
        population: "LV",
        right: 49,
        sponsor: "Nexstar Media",
      },
      {
        end: "2026-10-19",
        left: 47,
        pollster: "Beacon Research/Shaw & Co. Research",
        population: "LV",
        right: 52,
        sponsor: "Fox News",
      },
      {
        end: "2026-10-18",
        left: 48,
        pollster: "Texas Public Opinion Research",
        population: "LV",
        right: 51,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 46,
        pollster: "Pollfinity Research",
        population: "RV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-16",
        left: 48,
        pollster: "CBS News/YouGov",
        population: "LV",
        right: 52,
        sponsor: "CBS News",
      },
      {
        end: "2026-10-14",
        left: 46,
        pollster: "University of Houston Hobby School of Public Affairs",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-13",
        left: 46,
        pollster: "GS Strategy Group/New River Strategies",
        population: "LV",
        right: 48,
        sponsor: "The Cook Political Report",
      },
      {
        end: "2026-10-11",
        left: 45,
        pollster: "Marist University",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 47,
        pollster: "ReconMR",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 48,
        pollster: "YouGov",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 49,
        pollster: "University of Texas/Texas Politics Project",
        population: "LV",
        right: 48,
        sponsor: null,
      },
      {
        end: "2026-10-01",
        left: 49,
        pollster: "The New York Times/Siena",
        population: "LV",
        right: 46,
        sponsor: null,
      },
    ],
    special: false,
    state: "TX",
  },
  {
    office: "senate",
    polls: [
      {
        end: "2026-10-28",
        left: 48,
        pollster: "Quantus Insights",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-28",
        left: 52.1,
        note: "Two-way question",
        pollster: "ActiVote",
        population: "LV",
        right: 47.9,
        sponsor: null,
      },
      {
        end: "2026-10-27",
        left: 50.2,
        pollster: "A2 Insights",
        population: "LV",
        right: 47.2,
        sponsor: null,
      },
      {
        end: "2026-10-27",
        left: 49,
        pollster: "SSRS",
        population: "LV",
        right: 43,
        sponsor: "CNN",
      },
      {
        end: "2026-10-26",
        left: 51,
        pollster: "YouGov Blue",
        population: "LV",
        right: 43,
        sponsor: "254 Labs",
      },
      {
        end: "2026-10-25",
        left: 49,
        pollster: "Texas Southern University",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-21",
        left: 45,
        pollster: "Rasmussen Reports",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-21",
        left: 50,
        pollster: "Univision/YouGov",
        population: "RV",
        right: 45,
        sponsor: "Univision",
      },
      {
        end: "2026-10-20",
        left: 47.6,
        pollster: "Verasight",
        population: "LV",
        right: 45.2,
        sponsor: "VoteHub",
      },
      {
        end: "2026-10-19",
        left: 49,
        pollster: "Emerson College",
        population: "LV",
        right: 48,
        sponsor: "Nexstar Media",
      },
      {
        end: "2026-10-19",
        left: 49,
        pollster: "Beacon Research/Shaw & Co. Research",
        population: "LV",
        right: 49,
        sponsor: "Fox News",
      },
      {
        end: "2026-10-18",
        left: 51,
        pollster: "Texas Public Opinion Research",
        population: "LV",
        right: 47,
        sponsor: null,
      },
      {
        end: "2026-10-18",
        left: 48,
        pollster: "Pollfinity Research",
        population: "RV",
        right: 43,
        sponsor: null,
      },
      {
        end: "2026-10-16",
        left: 51,
        pollster: "CBS News/YouGov",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-15",
        left: 44,
        pollster: "Cor Strategies",
        population: "LV",
        right: 40,
        sponsor: "Heritage Action",
      },
      {
        end: "2026-10-14",
        left: 48,
        pollster: "InsiderAdvantage",
        population: "LV",
        right: 49,
        sponsor: null,
      },
      {
        end: "2026-10-14",
        left: 48,
        pollster: "University of Houston Hobby School of Public Affairs",
        population: "LV",
        right: 46,
        sponsor: null,
      },
      {
        end: "2026-10-13",
        left: 49,
        pollster: "GS Strategy Group/New River Strategies",
        population: "LV",
        right: 44,
        sponsor: "The Cook Political Report",
      },
      {
        end: "2026-10-11",
        left: 47,
        pollster: "Marist University",
        population: "LV",
        right: 45,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 47.1,
        pollster: "Trafalgar Group",
        population: "LV",
        right: 43.6,
        sponsor: null,
      },
      {
        end: "2026-10-08",
        left: 48,
        pollster: "ReconMR/Siena University",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 50,
        pollster: "YouGov",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-05",
        left: 50,
        pollster: "University of Texas/Texas Politics Project",
        population: "LV",
        right: 47,
        sponsor: null,
      },
    ],
    special: false,
    state: "TX",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-25",
        left: 46,
        pollster: "State Navigate",
        population: "LV",
        right: 49,
        sponsor: null,
      },
    ],
    special: false,
    state: "VT",
  },
  {
    office: "governor",
    polls: [
      {
        end: "2026-10-23",
        left: 47.7,
        pollster: "Wick",
        population: "LV",
        right: 44.6,
        sponsor: "League of American Workers",
      },
      {
        end: "2026-10-22",
        left: 51,
        pollster: "Marquette University Law School",
        population: "LV",
        right: 44,
        sponsor: null,
      },
      {
        end: "2026-10-09",
        left: 46,
        pollster: "YouGov",
        population: "A",
        right: 42,
        sponsor: "City Forward Collective and CFC Action Fund",
      },
      {
        end: "2026-10-01",
        left: 49,
        pollster: "Z to A Research",
        population: "LV",
        right: 44,
        sponsor: "Rust Belt Rising",
      },
    ],
    special: false,
    state: "WI",
  },
];
